import React from 'react';
import TVProgramCollage from '../../../../../components/TVProgramCollage';
import { Layout } from '../../../../../queries/ats/layout/types';
import { useChannels } from '../../../../../queries/channels/queries';
import { classes } from '../../../../../utils/commonUtils';
import styles from './SectionLivePrograms.module.scss';

interface SectionLiveProgramsProps {
  view: Layout.SectionView;
  className?: string;
}

export function SectionLivePrograms({ view, className }: SectionLiveProgramsProps) {
  const { data: channels, isLoading } = useChannels();

  if (isLoading) {
    return <SectionLiveProgramsSkeleton view={view} />;
  }
  if (!channels) {
    return null;
  }

  let clonedChannels = [...channels];
  let channelsToUse = clonedChannels.splice(0, 5);
  return (
    <div className={classes(styles.container, className)}>
      <TVProgramCollage title={view.label} channels={channelsToUse} />
    </div>
  );
}

interface SectionLiveProgramsSkeletonProps {
  view: Layout.SectionView;
}

function SectionLiveProgramsSkeleton({ view }: SectionLiveProgramsSkeletonProps) {
  return (
    <div className={styles.skeleton}>
      {view.label.length > 0 && <h3>{view.label}</h3>}
      <div className={styles.grid}>
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

SectionLivePrograms.Skeleton = SectionLiveProgramsSkeleton;
